define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi",
	"csi/action/FormData",
	"csi/table/New",
	"csi/wizard/ActionControllerMixin",
	"csi/xml",
	"csi/xml/Query",
	"Specification/SelectBOMAndColorAndSizeForm"
], function(array,declare,lang,csi,FormData,New,ActionControllerMixin,xml,Query,SelectBOMAndColorAndSizeForm) {

	var	FIELD_ALTERNATIVE = "ProductAlternative";
	var	FIELD_COLOR = "ProductColor";
	var	FIELD_SIZE = "ProductSize";

	return declare([New, ActionControllerMixin], {
		// FormData: form data storing selected BOM and BOM lines
		_bAddAll: false,
		_fdBOM: null,
		_fdBOMLines: null,
		_urlAlternative: null,
		_urlColor: null,
		_urlSize: null,

		preProcess: function() {
			this.m_typeNode = this.getParent().$Type === "MaterialSample" ? "MaterialBOM" : "ApparelBOM";
			this._fdBOM = this.getFormData();
			this._fdBOMLines = new FormData(this);
			this._fdBOMLines.m_fAggregateTest = lang.hitch(this, this._mustAggregatePlacement);

			this.inherited(arguments);
		},

		getWizardViewQuery: function(/*csi.wizard.Widget*/wizard, /*csi.view.Widget*/view, /*Number*/index) {
			// summary: return query for BOM-lines view
			if (index == 1) {
				var q = new Query();

				this._urlAlternative = this._fdBOM.getFieldValue(FIELD_ALTERNATIVE);
				this._urlColor = this._fdBOM.getFieldValue(FIELD_COLOR);
				this._urlSize = this._fdBOM.getFieldValue(FIELD_SIZE);

				if (xml.isValidURL(this._urlAlternative)) {
					q.Or()
						.RefAttr("OnlyForProductAlternatives", xml.OP_EQUALS, this._urlAlternative)
						.Attr2("OnlyForProductAlternatives", xml.OP_EQUALS, {Dimension:0});
				}

				if (xml.isValidURL(this._urlColor)) {
					q.Or()
						.RefAttr("OnlyForColors", xml.OP_EQUALS, this._urlColor)
						.Attr2("OnlyForColors", xml.OP_EQUALS, {Dimension:0});
				}

				if (xml.isValidURL(this._urlSize)) {
					q.Or()
						.RefAttr("OnlyForSizes", xml.OP_EQUALS, this._urlSize)
						.Attr2("OnlyForSizes", xml.OP_EQUALS, {Dimension:0});
				}

				return q.isEmpty() ? null : q;
			}

			return null;
		},

		onNextPage: function(/*csi.wizard.Widget*/wizard,
							 /*csi.wizard.Content*/currentPage,
							 /*csi.wizard.Content*/nextPage,
							 /*Boolean*/bFinish) {
			// summary: prepare the data and pass it into the next page
			var	bRefresh = false;
			var	dfd, fd;

			if (wizard.getIndexOfPage(nextPage) == 0) {
				// moving to select-BOM, -color, and -size form
				fd = this._fdBOM;
				fd.setNode(wizard.getViewNode());
			} else if (wizard.getIndexOfPage(nextPage) == 1) {
				// moving to table view of selected BOM's BOM lines
				fd = this._fdBOMLines;

				// refresh if selected BOM or Color has changed
				var selectedBOM = this._getSelectedBOM();
				if (fd.getNode() != selectedBOM) {
					fd.setNode(selectedBOM);
					bRefresh = true;
				}

				var urlAlternativeSelected = this._fdBOM.getFieldValue(FIELD_ALTERNATIVE);
				if (this._urlAlternative != urlAlternativeSelected) {
					this._urlAlternative = urlAlternativeSelected;
					bRefresh = true;
				}

				var urlColorSelected = this._fdBOM.getFieldValue(FIELD_COLOR);
				if (this._urlColor != urlColorSelected) {
					this._urlColor = urlColorSelected;
					bRefresh = true;
				}

				var urlSizeSelected = this._fdBOM.getFieldValue(FIELD_SIZE);
				if (this._urlSize != urlSizeSelected) {
					this._urlSize = urlSizeSelected;
					bRefresh = true;
				}

				if (bRefresh) {
					fd.resetAggregations();
					fd.resetSelections();
					fd.bPreselectAll = true;
				}

				if (bFinish) {
					fd = null;
				}
			}

			if (fd) {
				dfd = wizard.setFormDataToPage(nextPage, fd, bRefresh);
			}

			return dfd;
		},

		_mustAggregatePlacement: function(/*Context*/ctx, /*FormData*/fd) {
			// summary: force structured placements to be selected
		    if (xml.isValidURL(ctx.getNode().PSPlacement)) {
		        fd.addAggregatedNode(ctx.getNode());
		        return false;
		    } else {
		        return true;
		    }
		},

		_getSelectedBOM: function() {
			return this._fdBOM.getCache().getNode(this._fdBOM.getFieldValue("BOM"), true);
		},

		toWriterRequest: function() {
			// summary: send selected BOM lines as parameter
			var	call = this.inherited(arguments);
			if (call) {
				this.toWriterSelections(this._fdBOMLines, call, null);
			}

			return call;
		}
	});
});